import { render, staticRenderFns } from "./TripMaintenance.vue?vue&type=template&id=0e049b60&scoped=true"
import script from "./TripMaintenance.vue?vue&type=script&lang=js"
export * from "./TripMaintenance.vue?vue&type=script&lang=js"
import style0 from "./TripMaintenance.vue?vue&type=style&index=0&id=0e049b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e049b60",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GlobalDataTable: require('/home/vsts/work/1/s/components/global/DataTable.vue').default})
